export default __webpack_public_path__ + "static/media/assets-img-cook.1cd26edb.svg";